import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b1f3c5b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0b1f3c5b&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\oywen\\niehao\\qft\\20260317\\vue-admin-template-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1f3c5b')) {
      api.createRecord('0b1f3c5b', component.options)
    } else {
      api.reload('0b1f3c5b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b1f3c5b", function () {
      api.rerender('0b1f3c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Search/index.vue"
export default component.exports